/**
 * A wrong turn: nothing lives at this address. The catch-all route uses it as
 * is; pages that look something up by slug or id (a post, a member, a custom
 * page) pass their own title when the lookup comes back empty.
 */

import { Link } from 'react-router-dom';
import LeagueCrest from './LeagueCrest';

export default function NotFound({
  title = 'You’ve wandered off the map',
  message = 'Nothing lives at this address. The party’s been waiting for you back at base.',
}: {
  title?: string;
  message?: string;
}) {
  return (
    <div className="not-found">
      <LeagueCrest />
      <h2>{title}</h2>
      <p className="muted">{message}</p>
      <Link className="btn-cta primary" to="/">
        Back to base
      </Link>
    </div>
  );
}
